import { motion } from "framer-motion";

export const Testimonials = () => (
  <section id="sichern" className="relative py-24 lg:py-32 bg-void-soft/40" data-testid="final-cta-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-center"
      >
        <span className="stamp text-xs">Letzte Seite</span>
        <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-6xl font-bold text-white tracking-tight mt-8">
          Deine Akte wartet.
        </h2>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-400 max-w-xl mx-auto">
          75 Seiten, die du heute noch gelesen hast. Und morgen siehst du
          Menschen nie wieder wie vorher.
        </p>
        <a
          href="#books"
          data-testid="final-cta-button"
          className="glow-btn !text-base !px-10 !py-5 min-h-[56px] mt-10"
        >
          Jetzt Buch sichern · 19,99 €
        </a>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
          Sofort-Download · Sichere Zahlung · Band 1 der Trilogie
        </p>
      </motion.div>
    </div>
  </section>
);
